import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';

import Button from '../common/inputs/button';

const NoPeriodCreated = props => {
  const {
    handleCreatePeriod
  } = props;
  return (
    <div className="no_period_created_wrapper">
      <div className='no_period_created_wrapper_info'>
         <FormattedMessage id="periodAdmin.noPeriodCreated"/>
      </div>
      <Button
        onClick={handleCreatePeriod}
        labelLocale={<FormattedMessage 
           id="periodAdmin.createPeriod"
         />}
      />
    </div>
  );
};

export default NoPeriodCreated;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/noPeriodCreated.jsx